export { default as imageMap } from "./imageMap";
